{
  "--color-primary": ["#745C00", "#A1800A"],
  "--color-primary-opacity": ["#745C001E", "#A1800A1E"],
  "--color-primary-opacity-hover": ["#745C0040", "#A1800A40"],
  "--color-primary-tint": ["#745c001a", "#a1800a1a"],
  "--color-primary-shade": ["#5f4b00", "#8f7208"],
  "--color-background": ["#FFFFFF", "#1D1D1A"],
  "--color-background-compact-menu": ["#FFFFFFBB", "#1D1D1ADD"],
  "--color-web-app-browser": ["#FFFFFFBB", "#0303038F"],
  "--color-background-compact-menu-reactions": ["#FFFFFFEB", "#1D1D1ADD"],
  "--color-background-compact-menu-hover": ["#00000011", "#00000066"],
  "--color-background-secondary": ["#F6F5F0", "#141412"],
  "--color-background-secondary-accent": ["#E6E3D8", "#1A1A17"],
  "--color-background-sidebar": ["#E6E3D8", "#141412"],
  "--color-background-own": ["#FFF3B8", "#3A3527"],
  "--color-background-own-apple": ["#FFF3B8", "#3A3527"],
  "--color-background-selected": ["#F0EEE4", "#2A2A26"],
  "--color-background-own-selected": ["#FFEA8F", "#454031"],
  "--color-chat-hover": ["#F0EEE4", "#2A2A26"],
  "--color-chat-active": ["#745C00", "#6B5A12"],
  "--color-chat-active-greyed": ["#9C8A4A", "#7D6F3A"],
  "--color-item-hover": ["#F0EEE4", "#2A2A26"],
  "--color-item-active": ["#E6E3D8", "#32322D"],
  "--color-text": ["#1A1C1C", "#F2F1EA"],
  "--color-text-secondary": ["#6B6D65", "#A3A29A"],
  "--color-icon-secondary": ["#6B6D65", "#A3A29A"],
  "--color-text-secondary-apple": ["#76756B", "#A3A29A"],
  "--color-borders": ["#E6E3D8", "#32322D"],
  "--color-borders-input": ["#E6E3D8", "#5B5B55"],
  "--color-dividers": ["#D6D3C8", "#3B3B36"],
  "--color-dividers-android": ["#E6E3D8", "#141412"],
  "--color-links": ["#745C00", "#FFDF3D"],
  "--color-gray": ["#C4C3BA", "#737269"],
  "--color-list-icon": ["#ABAAA2", "#A2A19A"],
  "--color-default-shadow": ["#72727240", "#1010109c"],
  "--color-light-shadow": ["#7272722B", "#00000040"],
  "--color-green": ["#2F7D26", "#4B943F"],
  "--color-green-darker": ["#276B20", "#3F7C35"],
  "--color-success": ["#00C73E", "#00C73E"],
  "--color-text-meta-colored": ["#46AA36", "#55C246"],
  "--color-reply-hover": ["#F2F0E8", "#2A2A26"],
  "--color-reply-active": ["#E6E3D8", "#32322D"],
  "--color-reply-own-hover": ["#FFEA8F", "#454031"],
  "--color-reply-own-hover-apple": ["#FFEA8F", "#454031"],
  "--color-reply-own-active": ["#FFE170", "#504A38"],
  "--color-reply-own-active-apple": ["#FFE170", "#504A38"],
  "--color-accent-own": ["#745C00", "#D4C08A"],
  "--color-message-meta-own": ["#6E6236FF", "#C9BC84FF"],
  "--color-own-links": ["#745C00", "#FFDF3D"],
  "--color-code": ["#745C00", "#D4C08A"],
  "--color-code-own": ["#5f4b00", "#F2F1EA"],
  "--color-code-bg": ["#70757914", "#00000080"],
  "--color-code-own-bg": ["#70757914", "#00000050"],
  "--color-composer-button": ["#6B6D65CC", "#A3A29ACC"],
  "--color-message-reaction": ["#fff8d6", "#2e2b1f"],
  "--color-message-reaction-hover": ["#fff0a8", "#3a3527"],
  "--color-message-reaction-own": ["#ffe58a", "#544b2a"],
  "--color-message-reaction-hover-own": ["#ffdd66", "#5f5530"],
  "--color-message-reaction-chosen-hover": ["#5f4b00", "#8f7208"],
  "--color-message-reaction-chosen-hover-own": ["#5f4b00", "#F2F1EA"],
  "--color-message-non-contact": ["#FFF3B8", "#A3A29A"],
  "--color-voice-transcribe-button": ["#fff8d6", "#2e2b1f"],
  "--color-voice-transcribe-button-own": ["#ffe58a", "#544b2a"],
  "--color-topic-blue": ["#2F7772", "#6ff9f0"],
  "--color-topic-yellow": ["#7F693B", "#ffd67e"],
  "--color-topic-violet": ["#8B5A96", "#cb86db"],
  "--color-topic-green": ["#44774A", "#8eee98"],
  "--color-topic-rose": ["#9B576B", "#ff93b2"],
  "--color-topic-red": ["#EB6858", "#fb6f5f"],
  "--color-topic-grey": ["#6C6C6C", "#999999"],
  "--color-forum-unread-topic-hover": ["#edebe3", "#363631"],
  "--color-forum-hover-unread-topic-hover": ["#e6e3d8", "#3f3f3a"],
  "--color-chat-username": ["#745C00", "#F2F1EA"],
  "--color-borders-read-story": ["#C4C3BA", "#737269"],
  "--color-background-menu-separator": ["#0000001a", "#ffffff1a"],
  "--color-hover-overlay": ["#00000006", "#ffffff06"],
  "--color-toast-background": ["#202020CC", "#000000CC"]
}
